import { IconName } from 'design-system/components/Icon';
import { ComponentPropsWithoutRef, ReactElement } from 'react';

export enum EDataBlockCourseEmphasis {
  High = 'High',
  Low = 'Low',
}

export interface IDataBlockCourse extends ComponentPropsWithoutRef<'div'> {
  value: string;
  label: string | React.ReactNode;
  iconName?: IconName;
  iconClassname?: string;
  emphasis?: `${EDataBlockCourseEmphasis}`;
  endAdornment?: ReactElement;
  labelClassName?: string;
}
